import { legacyAuthConfig } from "./../config/legacy-auth.config.ts";
import { encryptionConfig } from "./../config/encription.config";
import { hubConnectorInterceptorConfig } from "./../config/hub-connector-interceptor.config";
import { BrowserModule } from "@angular/platform-browser";
import {
    CUSTOM_ELEMENTS_SCHEMA,
    ErrorHandler,
    Injectable,
    NgModule,
} from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HttpClientModule } from "@angular/common/http";
import { SharedModule } from "./shared/shared.module";
import { HeaderModule } from "./shared/components/header/header.module";
import { PageService } from "./shared/services/page.service";
import { ProposalAccessGuard } from "./shared/guards/proposal-access.guard";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FaqModule } from "./shared/components/faq/faq.module";
import {
    CurrencyMaskConfig,
    CurrencyMaskModule,
    CURRENCY_MASK_CONFIG,
} from "ng2-currency-mask";
import { LoadingModule } from "./shared/components/loading/loading.module";
import { TaggingModule } from "@afe/tagging";
import { taggingConfig } from "../config/tracing.config";
import { MonitoringService } from "./shared/services/monitoring.service";
import { ErrorViewerModule } from "./shared/components/error-viewer/error-viewer.module";
import { ErrorService } from "./shared/services/error.service";
import { CarouselModule } from "ngx-owl-carousel-o";
import { HubConnectorInterceptorModule } from "@afe/http-interceptors/hub-connector";
import { EncryptionModule, ENCRYPTION_CONFIG_TOKEN } from "@afe/encryption";
import { DLECCEncryptionModule } from "@afe/encryption/dlecc";

import { AuthenticationLegacyModule } from "@afe/authentication/legacy";

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
    constructor(public errorService: ErrorService) {}
    handleError(error) {
        this.errorService.add(error);
    }
}

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
    align: "right",
    allowNegative: true,
    decimal: ",",
    precision: 2,
    prefix: "R$ ",
    suffix: "",
    thousands: ".",
};

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        SharedModule,
        HeaderModule,
        FaqModule,
        ErrorViewerModule,
        LoadingModule,
        CurrencyMaskModule,
        TaggingModule.forRoot(taggingConfig),
        BrowserAnimationsModule,
        CarouselModule,
        HubConnectorInterceptorModule.forRoot(hubConnectorInterceptorConfig),
        EncryptionModule,
        DLECCEncryptionModule.forRoot(encryptionConfig),
        AuthenticationLegacyModule.forRoot(legacyAuthConfig),
    ],
    providers: [
        PageService,
        ProposalAccessGuard,
        MonitoringService,
        { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
        { provide: ENCRYPTION_CONFIG_TOKEN, useValue: encryptionConfig },
        {
            provide: ErrorHandler,
            useClass: CustomErrorHandler,
        },
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent],
})
export class AppModule {}
